import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';

/**
 * Props for `FiveImageCards`.
 */
export type FiveImageCardsProps =
  SliceComponentProps<Content.FiveImageCardsSlice>;

/**
 * Component for "FiveImageCards" Slices.
 */
const FiveImageCards = ({ slice }: FiveImageCardsProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="text-white"
    >
      <div className="flex md:py-28 pb-16 pt-6 flex-col md:flex-row justify-between md:pr-16">
        <div className="flex flex-col md:max-w-[40%] shrink justify-between items-center overflow-hidden">
          <div className="flex justify-start w-full px-5 md:px-0">
            <div className="md:px-16 pb-6 md:pb-12">
              <PrismicNextImage
                field={slice.primary.icon}
                className="self-start mb-8"
                width={37}
              />
              <div className="mb-6 md:h-auto">
                <PrismicRichText field={slice.primary.main_title} />
              </div>
              <PrismicRichText field={slice.primary.main_description} />
            </div>
          </div>
          <div className="w-[105%] items-center flex flex-col md:w-full h-[188px] md:h-auto justify-end overflow-hidden">
            <PrismicNextImage
              field={slice.primary.main_image}
              className="md:border-none border-solid border-[1px] border-black rounded-[20px] h-auto w-full"
            />
          </div>
        </div>
        <div className="md:max-w-[60%] flex flex-col md:flex-row md:flex-wrap justify-end gap-y-12 md:gap-8 px-5 md:p-0 py-16">
          {slice.primary.secondary_cards.map((card, index) => {
            return (
              <div key={`card_${index.toString()}`} className="md:w-[45%]">
                <div className="flex flex-col justify-between marquee-blurred-border overflow-hidden h-full bg-five-cards-gradient shadow-lg shadow-black/25 backdrop-blur-[47.5px]">
                  <div className="p-6">
                    <div className="mb-2">
                      <PrismicRichText field={card.title} />
                    </div>
                    <PrismicRichText field={card.description} />
                  </div>
                  <PrismicNextImage
                    field={card.image}
                    className="h-72 object-cover"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FiveImageCards;
